import { useMutation, useQueryClient } from '@tanstack/react-query';
import * as Api from '../api';
import * as Types from '../types';
import { useAuthContext } from '../context';

/** Phone + password login. Sets tokens; useProfile loads the rest. */
export const usePhoneLogin = () => {
  const queryClient = useQueryClient();
  const {
    methods: { setTokens },
  } = useAuthContext();

  return useMutation({
    mutationFn: async (values: Types.IApi.PhoneLogin.Request) => {
      const { data } = await Api.PhoneLogin(values);
      return data;
    },
    onSuccess: (data) => {
      // Remove cached profile so React Query does a fresh fetch (triggering
      // the permissions request) instead of serving stale data from the cache.
      queryClient.removeQueries({ queryKey: ['auth', 'profile'] });
      setTokens({ accessToken: data.accessToken, refreshToken: data.refreshToken });
    },
  });
};
